// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Interactive } from '@gandi/ui';

import { useNavigationTree } from '../../hooks';
import type { NavigationItems } from '../../types';
import {
  NavigationDropDown,
  type NavigationDropDownProps,
} from '../NavigationDropDown';

import styles from './SplitNavigation.scss';

export type Props = {
  menuPlacement?: NavigationDropDownProps['placement'],
  className?: string,
};

type LinkOrDropDownProps = {
  name: string,
  menu: NavigationItems,
  idx: number,
  buttonClassName: string,
  menuPlacement?: NavigationDropDownProps['placement'],
};

function LinkOrDropDown({
  name,
  menu,
  idx,
  buttonClassName,
  menuPlacement,
}: LinkOrDropDownProps) {
  return menu.length > 1 ? (
    <NavigationDropDown
      id={`navigation-dropdown-${idx}`}
      label={name}
      navigationItems={menu}
      buttonClassName={buttonClassName}
      placement={menuPlacement}
      tagName="li"
    />
  ) : (
    <li className={styles.singleLink}>
      <Interactive
        flex
        flexAlignItemsCenter
        flexJustifyCenter
        paddingX="xsmall"
        color="base"
        weight="regular"
        href={menu[0].href}
        to={menu[0].to}
        className={clsx(styles.link, buttonClassName)}
      >
        {name}
      </Interactive>
    </li>
  );
}

function SplitNavigation({
  menuPlacement,
  className,
}: Props): React.MixedElement {
  const navigationTree = useNavigationTree();
  const menus = ((Object.entries(navigationTree): any): Array<
    [string, NavigationItems],
  >).map(([name, menu], idx) => (
    <LinkOrDropDown
      name={name}
      menu={menu}
      menuPlacement={menuPlacement}
      idx={idx}
      key={name}
      buttonClassName={styles.buttonClassName}
    />
  ));

  return <ul className={clsx(className, styles.root)}>{menus}</ul>;
}

export default SplitNavigation;
